// import {
//   MyOrderStatusColors,
//   MyPaymentStatusColors
// } from '../../../../constants/order-status-enums';
import styles from "./itemOrder.module.css";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { orderDateTransformer } from "../../../../../src/services/objectTransformer/orders";
import { _set_seen } from "../../../../store/actions/notification_actions";
import { useDispatch, useSelector } from "react-redux";
import { API } from "../../../../request/api";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const ItemOrder = ({
  id,
  seen,
  status,
  payment_status,
  created_at,
  metadata,
  is_expired,
}) => {
  const {
    Login: { is_login },
  } = useSelector((state) => state);

  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const navigate = useLangNavigate();

  function clickHandler() {
    // Try all known places we might receive the order id from notification metadata
    const orderId =
      metadata?.saleor_order_id ||
      metadata?.order_id ||
      metadata?.orderId ||
      metadata?.order?.id ||
      metadata?.order?.order_id ||
      metadata?.id;
    if (!seen) {
      if (is_login) {
        API.post.seenNotification(id).finally(() => {
          dispatch(_set_seen(id));
        });
      } else {
        dispatch(_set_seen(id));
      }
    }
    if (orderId) {
      // Pass metadata along so the detail page can render immediately while fetching
      navigate(`/my-order/${orderId}`, {
        state: {
          metadata,
          created_at: created_at || metadata?.created_at,
          status: status || metadata?.status,
          payment_status: payment_status || metadata?.payment_status,
          seen,
          notification_id: id,
        },
      });
    }
  }

  return (
    <div
      className={`${styles.boxItem} ${
        is_expired ? styles.expiredOrder : !seen ? styles.unSeenOrder : ""
      }`}
    >
      <div className={styles.orderContent}>
        <div className={styles.orderHeader}>
          <span className={styles.orderHeaderTitle}>
            <span
              className={
                is_expired ? styles.statusDotExpired : styles.statusDotActive
              }
            />
            <span className={styles.mainTitle}>
              {t("summary.order_date")}
              {is_expired ? ` ${t("notifications.expired")}` : ""}
            </span>
          </span>
          <span className={styles.orderContentValue}>
            {orderDateTransformer({ created: created_at })?.created}
          </span>
        </div>
        {/* <div className={`${styles.seprator}`} /> */}
        <div>
          <span
            className={`${styles.orderContentTitle} ${
              i18n.dir() === "rtl"
                ? styles.orderContentTitleRtl
                : styles.orderContentTitleLtr
            }`}
          >
            {t("notifications.productName")} :{" "}
          </span>
          <span className={styles.orderContentValue}>
            {metadata?.product?.name}
          </span>
        </div>
        <div>
          <span
            className={`${styles.orderContentTitle} ${
              i18n.dir() === "rtl"
                ? styles.orderContentTitleRtl
                : styles.orderContentTitleLtr
            }`}
          >
            {t("notifications.quantity")} :{" "}
          </span>
          <span className={styles.orderContentValue}>{metadata?.quantity}</span>{" "}
        </div>
        <div>
          {/* <span
            className={`${styles.orderContentTitle} ${
              i18n.dir() === "rtl"
                ? styles.orderContentTitleRtl
                : styles.orderContentTitleLtr
            }`}
          >
            {t("notifications.delivery_date")} :{" "}
          </span>
          <span className={styles.orderContentValue}>
            {metadata?.delivery_date}
          </span>{" "} */}
        </div>
        <div>
          {/* <span
            className={`${styles.orderContentTitle} ${
              i18n.dir() === "rtl"
                ? styles.orderContentTitleRtl
                : styles.orderContentTitleLtr
            }`}
          >
            {t("notifications.center_name")} :{" "}
          </span> */}
          <span className={styles.orderContentValue}>
            {metadata?.service_center?.name}
          </span>{" "}
        </div>
      </div>
      <div className={`${styles.seprator}`} />
      <div className="w-full flex-row justify-between items-center">
        <div className={styles.btnContainer}>
          <Button
            type="primary"
            disabled={is_expired}
            onClick={(e) => {
              e.preventDefault();
              clickHandler(id, seen);
            }}
          >
            {metadata.type === "qr_code"
              ? t("notifications.qrCode")
              : t("notifications.moreDetail")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ItemOrder;
